__turbopack_context__.v({
  "className": "fasthand_68e43c03-module__CAdrna__className",
  "variable": "fasthand_68e43c03-module__CAdrna__variable",
});
